var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './Select.module.scss';
import { ArrowDown } from '../../assets/icons';
import { v4 as uuid } from 'uuid';
import { ANIMATE_HEIGHT } from '../../constants';
import { ClickDetector } from '../ClickDetector/ClickDetector';
import { Search } from '../Search/Search';
import { Chips } from '../Chips/Chips';
var Select = function (_a) {
    var _b, _c;
    var selected = _a.selected, label = _a.label, placeholder = _a.placeholder, disabled = _a.disabled, required = _a.required, multiple = _a.multiple, removeable = _a.removeable, small = _a.small, dropUp = _a.dropUp, noMargin = _a.noMargin, search = _a.search, error = _a.error, errorMessage = _a.errorMessage, options = _a.options, className = _a.className, id = _a.id, dataId = _a.dataId, onChange = _a.onChange;
    var _d = useState(false), opened = _d[0], setOpened = _d[1];
    var _e = useState([]), displayOptions = _e[0], setDisplayOptions = _e[1];
    var classes = "".concat(opened ? styles.Active : '', " ").concat(disabled ? styles.Disabled : '', " ").concat(error ? styles.Error : '');
    useEffect(function () {
        setDisplayOptions(options);
    }, [options]);
    useEffect(function () {
        !opened && setDisplayOptions(options);
    }, [opened]);
    var isOptionSelected = function (value) { return selected === null || selected === void 0 ? void 0 : selected.find(function (o) { return o.value === value; }); };
    var onSelectChange = function (option) {
        var selectedOpts;
        if (isOptionSelected(option.value)) {
            selectedOpts = selected.filter(function (o) { return o.value !== option.value; });
        }
        else {
            selectedOpts = __spreadArray(__spreadArray([], selected, true), [option], false);
        }
        if (!multiple) {
            setOpened(false);
        }
        onChange && onChange(multiple ? selectedOpts : [option]);
    };
    var renderActive = function () {
        if (!multiple)
            return selected[0].label;
        return _jsx(Chips, { options: selected, onChange: onChange, removeable: removeable && !disabled, primary: true, limit: 1 });
    };
    var renderOptions = function () {
        if (!displayOptions.length)
            return _jsx("span", __assign({ className: styles.NoOptions }, { children: "No options" }));
        return (_jsx(_Fragment, { children: displayOptions.map(function (opt) { return (_jsx("li", __assign({ className: "".concat(styles.Option, " ").concat(isOptionSelected(opt.value) ? styles.Active : ''), onClick: function () { return onSelectChange(opt); } }, { children: opt.label }), uuid())); }) }));
    };
    return (_jsxs("div", __assign({ id: id, className: cx(styles.SelectContainer, className, (_b = {},
            _b[styles.Small] = small,
            _b[styles.DropUp] = dropUp,
            _b)) }, { children: [label && (_jsxs("label", __assign({ className: styles.Label }, { children: [label, required && _jsx("span", __assign({ className: styles.Required }, { children: "*" }))] }))), _jsxs("div", __assign({ className: "".concat(styles.SelectWrapper, " ").concat(noMargin ? styles.NoMargin : ''), onClick: function () { return !disabled && !opened && setOpened(true); }, "data-testid": dataId }, { children: [_jsxs("div", __assign({ className: cx(styles.Select, classes, (_c = {}, _c[styles.Multiple] = multiple, _c)) }, { children: [!!selected.length && renderActive(), !selected.length && placeholder && _jsx("span", __assign({ className: styles.Placeholder }, { children: placeholder })), _jsx("i", __assign({ className: styles.Icon }, { children: _jsx(ArrowDown, {}) }))] })), !opened && error && errorMessage && (_jsx("span", __assign({ className: "".concat(styles.ErrorMessage, " ").concat(ANIMATE_HEIGHT) }, { children: errorMessage }))), opened && (_jsx(ClickDetector, __assign({ onOutsideClick: function () { return setOpened(false); }, dataId: 'detector' }, { children: _jsxs("div", __assign({ className: styles.OptionContainer, "data-testid": 'options', onClick: function (e) { return multiple && e.stopPropagation(); } }, { children: [search && (_jsx(Search, { data: options, searchProperty: 'label', onSearch: setDisplayOptions, small: true, noMargin: true, className: styles.Search })), _jsx("ul", __assign({ className: styles.Options }, { children: renderOptions() }))] })) })))] }))] })));
};
Select.propTypes = {
    selected: PropTypes.arrayOf(PropTypes.any).isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    multiple: PropTypes.bool,
    removeable: PropTypes.bool,
    small: PropTypes.bool,
    dropUp: PropTypes.bool,
    noMargin: PropTypes.bool,
    search: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.any).isRequired,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
    onChange: PropTypes.func,
};
Select.defaultProps = {
    selected: [],
};
export { Select };
//# sourceMappingURL=Select.js.map